export default {
  config: {
    data_table_expire_days: 366,
  },
  tags: ["limited-to-xdr"],
  api: [{ rule: ".*", allow: true }],
  page: [
    { rule: "getstarted/.*", allow: false },
    { rule: "dashboard/.*", allow: true },
    { rule: "settings/singlesignon", allow: false },
    { rule: "settings/.*", allow: true },
    { rule: "reporting/executivesummaries", allow: true },
    { rule: "reporting/.*", allow: true },
    { rule: "blumiraagent/.*", allow: true },
    { rule: "user/.*", allow: true },
    { rule: "singlesignon/.*", allow: false },
  ],
};
